import React, { useCallback, useEffect, useMemo, useState } from 'react';
import '../FieldSample.scss';
import { GridContainer, Grid } from '../../../shared/grid';
import { Autocomplete, TextField, Button, Modal, Tooltip, IconButton } from '@mui/material';
import { ONEDAY, isValidDate, errorResponse, checkUserFieldSampleCollector, ValidCharacters, validateCharacters, fieldSampleAreaEditor} from '../../../store/common';
import Box from '@mui/material/Box';
import ClearIcon from '@mui/icons-material/Clear';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { BreadCrumb } from 'src/shared/BreadCrumbs/BreadCrumb';
import { ROUTE_PATHS } from 'src/routes';
import AddIcon from '@mui/icons-material/Add';
import { SiteMetaData } from '../Sites/SiteMetaData';
import { useHistory, useLocation, useParams} from 'react-router';
import moment from 'moment-timezone';
import { Sample } from '../Samples/Sample';
import { Submit } from '../Modals/Submit';
import { Delete } from '../Modals/Delete';
import { NoSamplesOnSite } from '../Samples/NoSamplesOnSite';
import { useStoreContext } from 'src/store/context';
import { useAddAlert, useUser } from 'src/store/actions';
import { getCategoryByType, getCodes, getHeader, getSiteByKey, getSiteKeysForSearch, getSiteMetaData } from 'src/apis/getFuelSampleCalls';
import { SampleHeaderRow } from './SampleHeaderRow';
import LoadingSpinner from 'src/shared/loading/loading';
import { Site } from '../Sites/Site';
import { alertMessages } from 'src/constants';
import { modalStyle, submitModalStyle, deleteModalStyle } from 'src/shared/Styles/Styles';
// Callback function to handle data received from the child component

export const newSampleFromChildCallback = (newSampleIn:any, setIsChildCalledBack:any, setNewSampleFromChildComponent:any) =>{
  setIsChildCalledBack(true)
  setNewSampleFromChildComponent(newSampleIn)
}


export const FieldSampleChild: React.FC = () => {
    /* redux items*/
	const [state,dispatch] = useStoreContext();
  const addAlert = useAddAlert(dispatch);
  const setUser = useUser(dispatch);
  const [token, setToken] = useState<string|null>(null);

  const [openSiteMetaData, setOpenSiteMetaData] = useState(false);
  const location:any = useLocation(); 
  const [startDate, setStartDate] = useState<any>(moment(moment().valueOf()-(366*ONEDAY)).utc().toDate());
  const [endDate, setEndDate] = useState<any>(moment().utc().toDate());

  const [siteUseLocation, setSiteUseLocation] = useState<any>(location.state)
  const id_from_params = useParams<{ site_id: string }>();
  const [siteKeySearch, setSiteKeySearch] = useState(location.state?.site_key);

  const [groupId, setGroupId] = useState(siteUseLocation?.groupId);
  const [groupName, setGroupName] = useState(siteUseLocation?.groupName);
  const [areaName, setAreaName] = useState(siteUseLocation?.areaName);
  const [areaId, setAreaId] = useState(siteUseLocation?.areaId);

  const getSiteKey = useCallback(() => {
    (async () => {
        try {
            const siteKeys: any = await getSiteByKey(null, id_from_params.site_id);
            if (siteKeys.length === 1) {
              setSiteUseLocation(siteKeys[0])
              setSiteKeySearch(siteKeys[0].site_key);
              setGroupId(siteKeys[0].groupId);
              setGroupName(siteKeys[0].groupName);
              setAreaId(siteKeys[0].areaId);
              setAreaName(siteKeys[0].areaName)
            }
        }
        catch (error) {
            errorResponse(error, addAlert, alertMessages.fieldSampleHomeData)
        }
    })();
  }, [addAlert, id_from_params])

  useEffect(() => {
    if (!siteUseLocation) {
        getSiteKey();
    }
  }, [getSiteKey, siteUseLocation]);

  const [errorStartDate, setErrorStartDate] = useState<string|null>(null)
  const [errorEndDate, setErrorEndDate] = useState<string|null>(null);

  /* Sample editing, deleting*/
  const [openSampleModal, setOpenSampleModal] = useState(false);
  const [editSample, setEditSample] = useState<boolean>(false);
  const [sampleFromEdit, setSampleFromEdit] = useState<any>({});
  const [openSubmitModal, setOpenSubmitModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deletePressed, setDeletePressed] = useState(false);
  const [subSampleIdToDelete, setSubSampleIdToDelete] = useState(null);
  const [sampleToSubmit, setSampleToSubmit] = useState();
  const [typeToDelete, setTypeToDelete] = useState<string>('');
  const [sampleToDelete, setSampleToDelete] = useState();

  const [searchSiteKeys, setSearchSiteKeys] = useState<any[]>([]);
  const allCodeObj =  useMemo(()=>({code_key: "All",code_table_id: -1, code_value:'All', type:'All'}),[]);

  /* for method autocomplete*/
  const [sampleMethods, setSampleMethods] = useState<any[]>([allCodeObj]);
  const [method, setMethod] = useState<string|undefined>(sampleMethods[0].code_key);
  const [inputMethod, setInputMethod] = useState('');

  /* for sub category autocomplete*/
  const [sampleSubCats, setSampleSubCats] = useState<any[]>([allCodeObj]);
  const [subCategory, setSubCategory] = useState<string|undefined>(sampleSubCats[0].code_key);
  const [inputSubCategory, setInputSubCategory] = useState('');

  /* for category autocomplete*/
  const [sampleCategories, setSampleCategories] = useState<any[]>([allCodeObj]);
  const [filteredCategories, setFilteredCategories] =useState<any[]>([allCodeObj]);
  const [category, setCategory] = useState<string|undefined>(sampleCategories[0].code_key);
  const [inputCategory, setInputCategory] = useState('');

  /* for status autocomplete*/
  const [sampleStatus, setSampleStatus] = useState<any[]>([allCodeObj]);
  const [status, setStatus] = useState<string|undefined>(sampleStatus[0].code_key);
  const [inputStatus, setInputStatus] = useState('');

  /* for types autocomplete*/
  const [sampleTypes, setSampleTypes] = useState<any[]>([allCodeObj]);
  const [type, setType] = useState<string|undefined>(sampleTypes[0].code_key);
  const [inputType, setInputType] = useState('');

  /** track which items are headers */
  const [headers, setHeaders] = useState<any[]>();
  const [rowsStick, setRowsStick] = useState(headers); 

  const [addSampleCalled, setAddSampleCalled] = useState(false);
  const [sampleRecentlyAdded, setSampleRecentlyAdded] = useState<any>(null);

  const [siteMetaData, setSiteMetaData] = useState(siteUseLocation);
  const history = useHistory();
  const [allSamps, setAllSamps]=useState<any[]>([]);

  /* items to keep rows opened etc*/
  const [callBackToBeMade, setCallBackToBeMade] = useState<any>(null);
  const [sampleToReload, setSampleToReload] = useState<any>();
  const [archivedVerbiage, setArchivedVerbiage] = useState<boolean>(false);
  const [sampleClicked, setSampleClicked] = useState<boolean>(false);
  const [headerCalled, setHeaderCalled] = useState<boolean>(false);
  const [isChildCalledBack, setIsChildCalledBack] = useState<boolean>(false);
  const [newSampleFromChildComponent, setNewSampleFromChildComponent] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  /*FOR EDIT SITE BUTTON */
  const [openSiteModal, setOpenSiteModal] = useState(false);
  const [siteToEdit, setSiteToEdit] =useState<any>({siteId: id_from_params?.site_id});
  const [ siteCreatedSuccess,setSiteCreatedSuccess] = useState<any>(null);

  const [callMadeKey, setCallMadeKey] = useState(false);
  const [callMadeCodes, setCallMadeCodes] = useState(false);

  const fuelSampleMetaDataInput = useMemo(()=>({
    startDate: null,
    endDate: null,
    fuelType: "All",
    fuelSubCategory: "All",
    fuelMethod: "All",
    fuelCategory: "All",
  }),[])

  useEffect(()=>{
    if(!localStorage.getItem('user') && (!state.user || !checkUserFieldSampleCollector(state.user))){
      history.push('/ui')
    }
  },[state.user, history]);

  const dynamicTypesForSite = useCallback((idPresent?: any)=>{
    const requestVars = {
      startDate: startDate, /* if they want to change to any type for this sample and any date just send null*/
      endDate: endDate, 
      id: idPresent ? idPresent.id : id_from_params?.site_id, 
      status: 'All',
      category: 'All',
      subCategory: 'All',
      method: 'All',
      type: 'All'
    };
    (async()=>{
      try{
        const headersPromise:any = await getHeader(token, addAlert, requestVars);
        if (headersPromise.length > 0) {
          let typesForSite: any[] = [...new Set(headersPromise.map((item:any) => item.fuel_type))];
          typesForSite.sort(function(a, b) {
            return a.localeCompare(b);
         })
          typesForSite.unshift(allCodeObj.code_key);
          setSampleTypes(typesForSite)
        }
        else {
          setSampleTypes([allCodeObj.code_key])
        }

      }
      catch(error){
        errorResponse(error, addAlert, alertMessages.siteSampleData);
      } 
    })();
  },[addAlert, startDate, endDate,allCodeObj.code_key, token, id_from_params.site_id]);

  /*this method makes a call getHeader to then handle the response of getHeader call*/
  const handleResponseGetHeader = useCallback((request: any, fromAddSample: boolean) =>{
    setLoading(true);
    (async()=>{
      try{
        const heads:any = await getHeader(token, addAlert, request);
        if (heads.length > 0) {
          if (allSamps && allSamps.length > 0) {
            heads.forEach((head: any) => {
              let matchId = allSamps.find(a => a.fuel_type === head.fuel_type && 
                a.category === head.category && 
                a.sub_category === head.sub_category 
                && a.method === head.method
              );
              if (matchId) {
                if(fromAddSample){
                  head.samples=matchId.samples
                  head.pageInfo=matchId.pageInfo
                  head.opened=true
                }
                else{
                  head.samples=matchId.samples
                  head.pageInfo=matchId.pageInfo
                  head.opened=matchId.opened
                }

              } 
              else {
                if(fromAddSample){
                  head.opened=true;
                }
                else{
                  head.opened=false
                }
              }
            });
          }

          else {
            heads.forEach((header: any) => {
              if(fromAddSample){
                header.opened=true
              }
              else{
                header.opened=false
              }
            });
          }
          setAllSamps(heads);
          setHeaders(heads);
          setRowsStick(heads);
          setHeaderCalled(true);
          setLoading(false);

        }
        else {
          setHeaders(heads);
          setAllSamps(heads);
          setRowsStick(heads);
          setHeaderCalled(true);
          setLoading(false);
        }

      }
      catch(error){
        errorResponse(error, addAlert, alertMessages.siteSampleData);
        setLoading(false);
      } 
    })();
  },[addAlert, allSamps, token]);

  /* this will get the fuel type and category so they are filtered on the dropdown*/
  const toGetCategory = async (type?: string, cat?: string) => {
    try {
      const responseArray: any = await getCategoryByType(token, addAlert, type, cat);
      if (responseArray) {
        let uniqueCategories = [...new Set(responseArray.map((r: any) => r.category))];
        if(type) {
          uniqueCategories.unshift(allCodeObj.code_key);
          setFilteredCategories(uniqueCategories);
        }

      }
      else {
        setFilteredCategories([]);
      }
    }
    catch (error) {
      errorResponse(error, addAlert, alertMessages.siteSampleData);
    }
  };

  /* this useEffect makes the call to get the site keys*/
  useEffect(()=>{
    if(!callMadeKey && searchSiteKeys?.length<1){
      setCallMadeKey(true);
      (async()=>{
        try{
          const siteKeys:any = await getSiteKeysForSearch(token, addAlert);
          setSearchSiteKeys(siteKeys);
          setCallMadeKey(false);
        }
        catch(error){
          errorResponse(error, addAlert, alertMessages.siteSampleData);
          setCallMadeKey(false);
        } 
      })();
    }
  },[searchSiteKeys, token, addAlert, callMadeKey]);

  /* this use effect makes the call to get codes to update the dropdowns*/
  useEffect(()=>{
    if(!callMadeCodes && sampleSubCats.length<2 && state.user){
      setCallMadeCodes(true);
      (async()=>{
        try{
          const requestVars ={
            returnAll: true,
            type: null
          }
          const codeResponse:any = await getCodes(requestVars);

          dynamicTypesForSite()
          const cats = codeResponse.cats;
          cats.unshift(allCodeObj);
          const statuses = codeResponse.statuses;
          statuses.unshift(allCodeObj)
          const subCats = codeResponse.subCats;
          subCats.unshift(allCodeObj)
          const methods = codeResponse.methods;
          methods.unshift(allCodeObj);
          if(fieldSampleAreaEditor(state.user)){
            setSampleStatus(statuses);
          }
          else{
            const tempStatuses = statuses
            tempStatuses.splice(1,1);
            setSampleStatus(tempStatuses);
          }
          setSampleCategories(cats);
          setSampleSubCats(subCats);
          setSampleMethods(methods);
          setCallMadeCodes(false);
          const firstCall ={
            startDate: startDate,
            endDate: endDate, 
            id: id_from_params?.site_id, 
            status: status,
            category: category,
            subCategory: subCategory,
            method: method,
            type: type,
            fromHandleDate: false
          }
          handleResponseGetHeader(firstCall, false)
        }
        catch(error){
          errorResponse(error, addAlert, alertMessages.siteSampleData);
          setCallMadeCodes(false);

        } 
      })();
    }
  },[sampleSubCats, addAlert, allCodeObj, token, category, handleResponseGetHeader, id_from_params.site_id,
    method,startDate, status, subCategory, type, endDate,dynamicTypesForSite, callMadeCodes, state.user
  ]);

  useEffect(()=>{
    if(state.userTokens && token) {
      /** If the Token is refreshed this will set the @param token equal to updated value */
      setToken(state.userTokens.accessToken);
    }
    else if(localStorage.getItem('user') && state.userTokens && !token){
      /** find access token and set to send to bearer */
      const parsedSession = JSON.parse(localStorage.getItem('user')??'');
      setUser(parsedSession.userInfo);
      setToken(state.userTokens.accessToken);
    }
    else if(!state.user){
      const parsedSession = JSON.parse(localStorage.getItem('user')??'')
      setUser(parsedSession.userInfo)    
    }
  },[state.userTokens, state.user, token, setUser, setToken]);

  

  /* will check if callback has been set in one of the children 
  then it will check the type to see if a new header call should be made
    callBackToBeMade is set when a sample is deleted
  */
  useEffect(()=>{
    if(callBackToBeMade!==null){
      if(callBackToBeMade.type?.includes('getHeaders') || callBackToBeMade.type?.includes('getSamples') ){
        if(!callBackToBeMade.archived){
          dynamicTypesForSite();
          setMethod(sampleMethods[0].code_key);
          setSubCategory(sampleSubCats[0].code_key);
          setCategory(sampleCategories[0].code_key);
          setStatus(sampleStatus[0].code_key);
          setType(sampleTypes[0]);
          setStartDate(moment(moment().valueOf()-(366*ONEDAY)).utc().toDate());
          setEndDate(moment().utc().toDate());
          const callToMake ={
            startDate: moment(moment().valueOf()-(366*ONEDAY)).utc().toDate(),
            endDate: moment().utc().toDate(), 
            id: id_from_params?.site_id, 
            status: sampleStatus[0].code_key,
            category: sampleCategories[0].code_key,
            subCategory: sampleSubCats[0].code_key,
            method: sampleMethods[0].code_key,
            type: sampleTypes[0],
            fromHandleDate: false
          }
          handleResponseGetHeader(callToMake, false)
          setCallBackToBeMade(null);
        }
        else{
          const callToMake ={
            id: id_from_params?.site_id, 
            startDate: startDate,
            endDate: endDate, 
            status: status,
            category: category,
            subCategory: subCategory,
            method: method,
            type: type,
          }
          handleResponseGetHeader(callToMake, false);
          setCallBackToBeMade(null);

        }
      }

    }
  },[callBackToBeMade,handleResponseGetHeader, id_from_params.site_id, sampleCategories, sampleMethods, sampleStatus,
      sampleSubCats, sampleTypes, dynamicTypesForSite, category, startDate, endDate, method,  status, subCategory, type
  ]);

    /* will be a callback to change the dropdown values*/
    const handleNewSampleChildCallback = useCallback( (sample:any)=>{
      const newSampleValues ={
        id: id_from_params?.site_id, 
        startDate: moment(moment(sample.sampleDate).valueOf()-(ONEDAY)).utc().toDate(),
        endDate: moment(sample.sampleDate).utc().toDate(), 
        status: "All",
        category:sample.sampleCategory,
        subCategory:sample.sampleSubCategory,
        method: sample.sampleMethod,
        type: sample.sampleType,
        fromHandleDate: false
      }
      handleResponseGetHeader(newSampleValues, true);
  
        // SET THE VALUES 
      setStartDate(moment(moment(newSampleFromChildComponent.sampleDate).valueOf()-(ONEDAY)).utc().toDate());
      setEndDate(moment(newSampleFromChildComponent.sampleDate).utc().toDate());
      setMethod(newSampleFromChildComponent.sampleMethod);
      setStatus("All");
      setCategory(newSampleFromChildComponent.sampleCategory);
      setSubCategory(newSampleFromChildComponent.sampleSubCategory);
      setType(newSampleFromChildComponent.sampleType);
      setNewSampleFromChildComponent(null)

    },[handleResponseGetHeader, id_from_params?.site_id, newSampleFromChildComponent]);


  /*use effect to trigger the header call for the change of dropdown values after making a new sample*/
  useEffect(()=>{
    if(isChildCalledBack && newSampleFromChildComponent){
      dynamicTypesForSite()
      setSampleClicked(true);
      setIsChildCalledBack(false);
      handleNewSampleChildCallback(newSampleFromChildComponent);
    }
  },[handleNewSampleChildCallback, isChildCalledBack, newSampleFromChildComponent, dynamicTypesForSite]);

  const getSiteInfo= useCallback(()=>{
    //if sitemetadata is open then send a call to api
    (async()=>{
      try{
          const siteMeta:any = await getSiteMetaData(token, addAlert, id_from_params.site_id, fuelSampleMetaDataInput);
          setSiteMetaData(siteMeta[0])
        }
      catch(error){
        errorResponse(error, addAlert, alertMessages.siteSampleData);
      } 
    })();
  },[token, addAlert, id_from_params?.site_id, fuelSampleMetaDataInput]);

  const handleSiteMetaButton= () => {
    setOpenSiteMetaData(!openSiteMetaData);
    if(openSiteMetaData!==true){
      getSiteInfo()
    }
  }
  
  
  /* this will handle a new sample being clicked*/
  const onAddNewSampleClick =()=>{
    setEditSample(false);
    setSampleFromEdit({});
    setOpenSampleModal(true);
  }

  /* this will handle a sample close*/
  const handleCloseSample= (_event, reason) => {
    if (reason && reason === "backdropClick") 
        return;
    setOpenSampleModal(false); 
  }

  /* this will handle a sample that is clicked with dropdowns already assigned to modal*/
  const onEditExistingSample = (sample: any) =>{
    setEditSample(true);
    setSampleFromEdit(sample);
    setOpenSampleModal(true);
  }

  /* this will close the submit*/
  const handleCloseSubmit= (event, reason) => {
    if (reason && reason === "backdropClick") 
        return;
    setOpenSubmitModal(false); 
  }


  /* this will close the delete modal*/
  const handleCloseDelete= (event, reason) => {
    if (reason && reason === "backdropClick") 
        return;
    setOpenDeleteModal(false); 
  }

  /* this will clear filters*/
  const clearFilters =()=>{
    dynamicTypesForSite()
    setMethod(sampleMethods[0].code_key);
    setSubCategory(sampleSubCats[0].code_key);
    setCategory(sampleCategories[0].code_key);
    setStatus(sampleStatus[0].code_key);
    setType(sampleTypes[0]);
    setStartDate(moment(moment().valueOf()-(366*ONEDAY)).utc().toDate());
    setEndDate(moment().utc().toDate());
    const clearFilts ={
      startDate: moment(moment().valueOf()-(366*ONEDAY)).utc().toDate(),
      endDate: moment().utc().toDate(), 
      id: id_from_params?.site_id, 
      status: sampleStatus[0].code_key,
      category: sampleCategories[0].code_key,
      subCategory: sampleSubCats[0].code_key,
      method: sampleMethods[0].code_key,
      type: sampleTypes[0],
      fromHandleDate: false
    }
    handleResponseGetHeader(clearFilts,false);
  }

  /* this will handle start date*/
  const handleStartDate = (newValue: any)=>{
    dynamicTypesForSite()
    if( !isValidDate(newValue) ){
      setErrorStartDate('Invalid Date');
      return;
    }
    setStartDate(moment(newValue).utc().toDate());
    const handleStart={
      startDate: moment(newValue).utc().toDate(),
      endDate: endDate, 
      id: id_from_params?.site_id, 
      status: status,
      category: category,
      subCategory: subCategory,
      method: method,
      type: type,
      fromHandleDate: true
    }
    handleResponseGetHeader(handleStart, false)
    if((moment(newValue) <= moment(endDate))){
      if(errorEndDate=== 'Invalid Date' || (moment()<=moment(startDate)) || moment()<=moment(endDate) || newValue=== 'Invalid Date'){
        return
      }
      
      else{
        if(errorEndDate!=='Invalid Date'){
          setErrorEndDate(null)
        }        
        setErrorStartDate(null)
      }
    }
    else if(moment(newValue) > moment(endDate)) {
      setErrorStartDate('Start Date is after End Date');
    }
    else{
      setErrorStartDate('Invalid Date');
    }
  }

  /* this will handle end date changed*/
  const handleEndDate = (newValue: any)=>{
    dynamicTypesForSite()
    if( !isValidDate(newValue) ){
      setErrorEndDate('Invalid Date');
      return;
    }
    setEndDate(moment(newValue).utc().toDate());
    const paramEndHandle ={
      startDate: startDate,
      endDate: moment(newValue).utc().toDate(), 
      id: id_from_params?.site_id, 
      status: status,
      category: category,
      subCategory: subCategory,
      method: method,
      type: type,
      fromHandleDate: true

    }

    handleResponseGetHeader(paramEndHandle, false);
    if((moment(newValue) >= moment(startDate))){
      if(errorStartDate=== 'Invalid Date' || (moment()<=moment(startDate)) || (moment()<=moment(endDate)) || newValue=== 'Invalid Date'){
        return
      }
      else{
        setErrorEndDate(null)
        if(errorStartDate!=='Invalid Date'){
          setErrorStartDate(null)
        }        
      }
    }
    else if(moment(newValue) < moment(startDate)){
      setErrorEndDate('End Date is before Start Date');
    }
    else{
      setErrorEndDate('Invalid Date');
    }
  }

  /* this will handle searching sites*/
  const handleSearchSites=(e:React.SyntheticEvent<Element, Event>, incomingVal: any)=>{
    let val:any = incomingVal?.site_id;
    let key:any = incomingVal?.site_key
    setSiteKeySearch(key)
    if(val){
      (async()=>{
        try{
          const siteKeys:any = await getSiteByKey(token, val);
          const siteKey:any = {...siteKeys[0]} 
          if(siteKeys.length===1){
            history.push({
              pathname:`/field_sample/${siteKeys[0].siteId}`,
              state: siteKey
            });
            
            const idPresent ={
              startDate: startDate,
              endDate: endDate, 
              id: siteKeys[0].siteId, 
              status: status,
              category: category,
              subCategory: subCategory,
              method: method,
              type: type,
              fromHandleDate: false
            }
            dynamicTypesForSite(idPresent)
            handleResponseGetHeader(idPresent, false);
            const siteMeta:any = await getSiteMetaData(token, addAlert, siteKeys[0].siteId, fuelSampleMetaDataInput);
            setSiteMetaData(siteMeta[0]);
            setGroupId(siteMeta[0].groupId);
            setGroupName(siteMeta[0].groupName);
            setAreaId(siteMeta[0].areaId);
            setAreaName(siteMeta[0].areaName)
            
          }
          else{
            errorResponse(siteKeys, addAlert, alertMessages.siteSampleData);
          }
        }
        catch(error){
          errorResponse(error, addAlert, alertMessages.siteSampleData);
        } 
      })();
    }
	}

  /* this will handle bread crumb clicked*/

  const handleOpenSiteModal = (siteId: any)=>{
    const editThisSite={
      siteId: siteId
    }
    setSiteToEdit(editThisSite)
    setOpenSiteModal(true);
  }     

  const handleCloseSiteModel = ()=>{
    setOpenSiteModal(false);
  }  

  const deleteParametersToSendToModal={
    setOpen: setOpenDeleteModal,
    open: openDeleteModal,
    setDeletePressed: setDeletePressed,
    setSubSampleIdToDelete: setSubSampleIdToDelete,
    typeToDelete: typeToDelete,
    setTypeToDelete: setTypeToDelete,
    setSampleToDelete: setSampleToDelete,
    archivedVerbiage: archivedVerbiage,
  }

  useEffect(()=>{
    if(siteCreatedSuccess){
      getSiteInfo();
      setSiteCreatedSuccess(null)
    }
  },[getSiteInfo, siteCreatedSuccess]);

  useEffect(()=>{
    if(!siteMetaData){
      getSiteInfo()
    }
  },[siteMetaData, getSiteInfo])

  return (
    state.user && checkUserFieldSampleCollector(state.user) &&
    <div className='table-page-container' data-testid={'table-page-container'}>
      <Modal //Modal to open the Site Modal
        className="smooth-scrollbar"
        open={openSiteModal}
        onClose={handleCloseSiteModel}
      >
        <div>
          <IconButton aria-label='close' style={{left: '73.5%', top: '5.5%', position: 'absolute', cursor: 'pointer'}} onClick={()=>{setOpenSiteModal(false)}}>
            <CloseIcon style={{color: 'white'}}/>
          </IconButton>
          <Box sx={modalStyle} className="smooth-scrollbar removePadding">
            {
              <Site setOpen={setOpenSiteModal} setSiteCreatedSuccess ={setSiteCreatedSuccess} editSite={siteToEdit} />
            }
          </Box>
        </div>
      </Modal>    
      <Modal
        className="smooth-scrollbar"
        open={openSampleModal}
        onClose={handleCloseSample}
      >
        <div style={{ height: '100%' }}>
          <IconButton aria-label='close' style={{ left: '73.5%', top: '5.5%', position: 'absolute', cursor: 'pointer' }} onClick={() => { setOpenSampleModal(false) }} >
            <CloseIcon style={{ color: 'white' }} />
          </IconButton>
          <Box sx={modalStyle} className="smooth-scrollbar removePadding">
            {
              editSample ? (
                <Sample setOpen={setOpenSampleModal} id={id_from_params?.site_id} open={openSampleModal}
                  setAddSampleCalled={setAddSampleCalled} editSample={sampleFromEdit} isNew={!editSample}
                  sampleCallBack={{ setIsChildCalledBack: setIsChildCalledBack, setNewSampleFromChildComponent: setNewSampleFromChildComponent, setSampleRecentlyAdded: setSampleRecentlyAdded}}
                />

              ) : (
                <Sample setOpen={setOpenSampleModal} id={id_from_params?.site_id} open={openSampleModal}
                  setAddSampleCalled={setAddSampleCalled} isNew={!editSample}
                  sampleCallBack={{ setIsChildCalledBack: setIsChildCalledBack, setNewSampleFromChildComponent: setNewSampleFromChildComponent,setSampleRecentlyAdded: setSampleRecentlyAdded }}
                />
              )
            }
          </Box>
        </div>

      </Modal>
      <Modal
        className="smooth-scrollbar"
        open={openSubmitModal}
        onClose={handleCloseSubmit}
      >
        <div style={{ height: '100%' }}>
          <IconButton aria-label='close' style={{ left: '64%', top: '32.5%', position: 'absolute', cursor: 'pointer' }} onClick={()=>setOpenSubmitModal(false)}>
            <CloseIcon style={{ color: 'white' }} />
          </IconButton>
          <Box sx={submitModalStyle} className="smooth-scrollbar removePadding">
            <Submit setOpen={setOpenSubmitModal} open={openSubmitModal} sampleToSubmit={sampleToSubmit} setSampleToSubmit={setSampleToSubmit} />
          </Box>
        </div>
      </Modal>

      <Modal
        className="smooth-scrollbar"
        open={openDeleteModal}
        onClose={handleCloseDelete}
      >
        <div style={{ height: '100%' }}>
          <IconButton aria-label='close' style={{ left: '64%', top:'23.5%', position: 'absolute', cursor: 'pointer' }} onClick={(e)=>handleCloseDelete(e,'click')} >
            <CloseIcon style={{ color: 'white' }} />
          </IconButton>
          <Box sx={deleteModalStyle} className="smooth-scrollbar removePadding">
            <Delete allFunctionsFromFieldSampleChild={deleteParametersToSendToModal} />
          </Box>
        </div>
      </Modal>

      <BreadCrumb finalCrumb={siteMetaData?.siteName} prevCrumb={[
      { label: 'Field Sample Home', path: ROUTE_PATHS.field_samples, queries: {groupName: "All", groupId: null, areaId: "All", areaName: "All"} }, 
      { label: areaName, path: `/area/${areaId}`, queries: {"groupId": null, "groupName": "All", "areaId": areaId, "areaName": areaName}},
      { label: groupName, path: `/group/${groupId}`, queries: {"groupId": groupId, "groupName": groupName, "areaBread": areaName, "areaBreadId": areaId} }]} />

      <GridContainer className='table-bar'>
        <colgroup>
          <col width="15%" />
          <col width="10%" />
          <col width="75%" />
        </colgroup>
        <tbody>
          <tr>
            <td style={{ color: 'black', fontSize: 'x-large' }}>{siteMetaData?.siteName}</td>
            <td style={{ fontSize: 'medium' }}>
              <button className="usa-accordion__button button-meta-data"
                type='button'
                data-testid={'open-site-meta-data-button'}
                aria-expanded={openSiteMetaData}
                onClick={handleSiteMetaButton}>SITE METADATA</button>
            </td>
            <td style={{ textAlign: 'right' }}>
              <div className='searchSites'>
                <i className="fas fa-search" />
                <Autocomplete
                  freeSolo
                  onChange={(e, value) => handleSearchSites(e, value)}
                  options={searchSiteKeys.map((option, index) => ({
                    ...option,
                    uniqueKey: `${option.site_key}-${index}`
                  }))}
                  filterOptions={(options, state)=>{
                    const inputValue = state.inputValue.trim().toLowerCase().split(/[ -]+/);
                    const filtered = options.filter((option)=>{
                      const optionWords = option.site_key.toLowerCase().split(/[ -]+/)

                      return inputValue.every((word)=>{
                        return optionWords.some((optionWord)=> optionWord.startsWith(word))
                      })
                    })
                    return filtered
                  }}
                  getOptionLabel={(option) => option.display_key}
                  value={siteKeySearch?.site_key}
                  renderInput={(params) => (
                    <TextField
                    onInput={(e) => validateCharacters(e, ValidCharacters.TextField, ValidCharacters.Hyphen)}
                      data-testid={'search-bar'}
                      {...params}
                      label="Search All Sites..."
                      InputProps={{
                        ...params.InputProps,
                        type: 'search',
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option.uniqueKey}>
                      {option.display_key}
                    </li>
                  )}
                />
              </div>
            </td>
          </tr>
          <tr></tr>
        </tbody>
      </GridContainer>
      {openSiteMetaData && <SiteMetaData fromFieldSample={true} site={siteMetaData} handleOpenSiteModal={handleOpenSiteModal}/>}

      <GridContainer className="margin-top-3 dropdown-style">
        <Grid row gap="md">
          <div style={{ width: '12.5%' }}>
            <label className="font-sans-md text-bold" htmlFor='sampleStartDate'>Sample Start Date</label>
          </div>
          <div style={{ width: '12.5%' }}>
            <label className="font-sans-md text-bold" htmlFor='sampleEndDate'>Sample End Date</label>
          </div>
          <div style={{ width: '15%' }}>
            <label className="font-sans-md text-bold" htmlFor='sampleType'>Sample Type</label>
          </div>
          <div style={{ width: '12.5%' }}>
            <label className="font-sans-md text-bold" htmlFor='sampleStatus'>Sample Status</label>
          </div>
          <div style={{ width: '16%' }}>
            <label className="font-sans-md text-bold" htmlFor='sampleCategory'>Category</label>
          </div>
          <div style={{ width: '16%' }}>
            <label className="font-sans-md text-bold" htmlFor='subCategory'>Sub-Category</label>
          </div>
          <div style={{ width: '15.5%' }}>
            <label className="font-sans-md text-bold" htmlFor='method'>Method</label>
          </div>
        </Grid>
        <Grid row gap="md" className="margin-top-1">
          <div style={{ width: '12.5%' }}>
            <DatePicker
              disableFuture
              value={startDate}
              slotProps={{
                textField: {
                  error: errorStartDate ? true : false,
                  helperText: errorStartDate,
                  id:'sampleStartDate',
                },

              }}
              onError={(reason) => {
                if (reason === 'disableFuture') {
                  setErrorStartDate('Start Date is in the Future');
                }
                else if (reason === 'invalidDate') {
                  setErrorStartDate('Invalid Date');
                }
                else if (reason === null && moment(startDate) <= moment(endDate)) {
                  if(errorEndDate!=='Invalid Date'){
                    setErrorEndDate(null)
                  }  
                  setErrorStartDate(null);
                }
                else if (moment(startDate) > moment(endDate)) {
                  setErrorStartDate('Start Date is after End Date');
                }
                else {
                  setErrorStartDate('An Error on Start Date')
                }
              }}
              onChange={(newValue) => { handleStartDate(newValue) }}
            />
          </div>
          <div style={{ width: '12.5%' }}>
            <DatePicker
              value={endDate}
              disableFuture
              aria-labelledby='sampleEndDate'

              onError={(reason) => {
                if (reason === 'disableFuture') {
                  setErrorEndDate('End Date is in the Future');
                }
                else if (reason === 'invalidDate') {
                  setErrorEndDate('Invalid Date');
                }
                else if (reason === null && moment(startDate) <= moment(endDate)) {
                  if(errorStartDate!=='Invalid Date'){
                    setErrorStartDate(null)
                  }  
                  setErrorEndDate(null);
                }
                else if (moment(startDate) > moment(endDate)) {
                  setErrorEndDate('End Date is before End Date');
                }
                else {
                  setErrorStartDate('An Error on Start Date')
                }
              }}
              slotProps={{
                textField: {
                  error: errorEndDate ? true : false,
                  helperText: errorEndDate,
                  id:'sampleEndDate',

                },
              }}
              onChange={(newValue) => handleEndDate(newValue)}
            />
          </div>
          <div style={{ width: '15%' }}>
            <Autocomplete
              className="height-55"
              value={type}
              aria-labelledby='sampleType'
              id="sampleType"
              onChange={(event: any, newValue: any) => {
                setType(newValue);
                toGetCategory(newValue);
                const typeChange = {
                  startDate: startDate,
                  endDate: endDate,
                  id: id_from_params?.site_id,
                  status: status,
                  category: category,
                  subCategory: subCategory,
                  method: method,
                  type: newValue,
                  fromHandleDate: false
                }
                handleResponseGetHeader(typeChange, false);
              }}
              inputValue={inputType}
              onInputChange={(event, newInputValue) => {
                setInputType(newInputValue);
              }}
              disableClearable
              options={(sampleTypes)}
              renderInput={(params) => (
                <TextField
                  onInput={(e) => validateCharacters(e, ValidCharacters.TextField, ValidCharacters.Hyphen, ValidCharacters.Comma)}
                  data-testid={'fuel_type'}
                  {...params}
                  label=""
                  InputProps={{
                    ...params.InputProps,
                    type: 'search',
                  }}
                />
              )}
            />
          </div>
          <div style={{ width: '12.5%' }}>
            <Autocomplete
              className="height-55"
              value={status}
              onChange={(event: any, newValue: any) => {
                setStatus(newValue);
                const statusChange = {
                  startDate: startDate,
                  endDate: endDate,
                  id: id_from_params?.site_id,
                  status: newValue,
                  category: category,
                  subCategory: subCategory,
                  method: method,
                  type: type,
                  fromHandleDate: false
                }
                handleResponseGetHeader(statusChange, false);
              }}
              inputValue={inputStatus}
              onInputChange={(event, newInputValue) => {
                setInputStatus(newInputValue);
              }}
              disableClearable
              aria-labelledby='sampleStatus'
              id="sampleStatus"
              options={sampleStatus.map((option) => option.code_key)}
              renderInput={(params) => (
                <TextField
                onInput={(e) => validateCharacters(e, ValidCharacters.TextField)}
                  data-testid={'fuel_status'}
                  {...params}
                  label=""
                  InputProps={{
                    ...params.InputProps,
                    type: 'search',
                  }}
                />
              )}
            />
          </div>
          <div style={{ width: '16%' }}>
            <Autocomplete
              className="height-55"
              value={category}
              onChange={(event: any, newValue: any) => {
                setCategory(newValue);
                toGetCategory(type, newValue);
                const categoryChange = {
                  startDate: startDate,
                  endDate: endDate,
                  id: id_from_params?.site_id,
                  status: status,
                  category: newValue,
                  subCategory: subCategory,
                  method: method,
                  type: type,
                  fromHandleDate: false
                }
                handleResponseGetHeader(categoryChange, false);
              }}
              inputValue={inputCategory}
              onInputChange={(event, newInputValue) => {
                setInputCategory(newInputValue);
              }}
              disableClearable
              aria-labelledby='sampleCategory'
              id="sampleCategory"              
              options={filteredCategories.length > 1 ? (filteredCategories) : (sampleCategories.map((option) => option.code_key))}
              renderInput={(params) => (
                <TextField
                  onInput={(e) => validateCharacters(e, ValidCharacters.TextField)}
                  data-testid={'fuel_category'}
                  {...params}
                  label=""
                  InputProps={{
                    ...params.InputProps,
                    type: 'search',
                  }}
                />
              )}
            />
          </div>
          <div style={{ width: '16%' }}>
            <Autocomplete
              className="height-55"
              value={subCategory}
              onChange={(event: any, newValue: any) => {
                setSubCategory(newValue);
                const subCategoryChange = {
                  startDate: startDate,
                  endDate: endDate,
                  id: id_from_params?.site_id,
                  status: status,
                  category: category,
                  subCategory: newValue,
                  method: method,
                  type: type,
                  fromHandleDate: false
                }
                handleResponseGetHeader(subCategoryChange, false)
              }}
              inputValue={inputSubCategory}
              onInputChange={(event, newInputValue) => {
                setInputSubCategory(newInputValue);
              }}
              disableClearable
              aria-labelledby='subCategory'
              id="subCategory"              
              options={sampleSubCats.map((option) => option.code_key)}
              renderInput={(params) => (
                <TextField
                onInput={(e) => validateCharacters(e, ValidCharacters.TextField)}
                  data-testid={'fuel_sub_category'}
                  {...params}
                  label=""
                  InputProps={{
                    ...params.InputProps,
                    type: 'search',
                  }}
                />
              )}
            />
          </div>
          <div style={{ width: '15.5%' }}>
            <Autocomplete
              className="height-55"
              value={method}
              onChange={(event: any, newValue: any) => {
                setMethod(newValue);
                const methodChange = {
                  startDate: startDate,
                  endDate: endDate,
                  id: id_from_params?.site_id,
                  status: status,
                  category: category,
                  subCategory: subCategory,
                  method: newValue,
                  type: type,
                  fromHandleDate: false
                }
                handleResponseGetHeader(methodChange, false)
              }}
              inputValue={inputMethod}
              onInputChange={(event, newInputValue) => {
                setInputMethod(newInputValue);
              }}
              disableClearable
              id="method"
              aria-labelledby='method'
              options={sampleMethods.map((option) => option.code_key)}
              renderInput={(params) => (
                <TextField
                onInput={(e) => validateCharacters(e, ValidCharacters.TextField)}
                  data-testid={'fuel_method'}
                  {...params}
                  label=""
                  InputProps={{
                    ...params.InputProps,
                    type: 'search',
                  }}
                />
              )}
            />
          </div>
        </Grid>
        <Grid row gap="sm" style={{ paddingTop: '10px' }}>
          <Grid desktop={{ col: 10 }}>

            <button aria-label='Clear Filters' style={{border:'0',backgroundColor: 'transparent', color: "#707070", textDecoration: 'underline', cursor: 'pointer' }} type='button' onClick={clearFilters}>
              <ClearIcon style={{ fontSize: 'small' }} />Clear Filters
            </button>
          </Grid>
          <Grid desktop={{ col: 2 }} style={{ paddingLeft: '5%' }}>
            {
              !siteMetaData?.siteStatus.includes('Inactive') &&
              <Tooltip title="New Sample" placement="top-start">
                <Button variant="outlined" onClick={onAddNewSampleClick} style={{ textTransform: 'none' }}><AddIcon fontSize='small' />New Sample</Button>
              </Tooltip>
            }
          </Grid>
        </Grid>
      </GridContainer>

        <TableContainer component={Paper} className='margin-top-2 first-table'>
          <Table aria-label="collapsible table">
            <colgroup>
              <col width="5%" />
              <col width="20%" />
              <col width="20%" />
              <col width="15%" />
              <col width="30%" />
              <col width="10%" />

            </colgroup>
            <TableHead style={{ backgroundColor: "#ededed" }}>
              <TableRow>
                <td key ={`style-field-sample-child-accordion`} style={{padding: 'checkbox'}} className="headerParent" >&nbsp;</td>
                <TableCell tabIndex={0} className='text-align-override'>TYPE</TableCell>
                <TableCell tabIndex={0} className='text-align-override'>CATEGORY</TableCell>
                <TableCell tabIndex={0} className='text-align-override'>SUB-CATEGORY</TableCell>
                <TableCell tabIndex={0} className='text-align-override'>METHOD</TableCell>
                <td key ={`style-field-sample-child-add-button`} style={{padding: 'checkbox'}} className="headerParent" >&nbsp;</td>

              </TableRow>
            </TableHead>
            {loading ? (
              <div className='heightImportant'>
                <LoadingSpinner />
              </div>
            ) : (
            <TableBody>

              {rowsStick ? (
                rowsStick.map((row, index) => {
                  let createValues = {
                    row: row,
                    startDate: startDate,
                    endDate: endDate,
                    parentArray: rowsStick,
                    token: token,
                    index: index,
                    allSamps: allSamps,
                    setAllSamps: setAllSamps,
                    setRowsStick: setRowsStick,
                    setOpenSubmitModal: setOpenSubmitModal,
                    setOpenDeleteModal: setOpenDeleteModal,
                    onEditExistingSample: onEditExistingSample,
                    setAddSampleCalled: setAddSampleCalled,
                    deletePressed: deletePressed,
                    setDeletePressed: setDeletePressed,
                    setSubSampleIdToDelete: setSubSampleIdToDelete,
                    subSampleIdToDelete: subSampleIdToDelete,
                    setSampleToSubmit: setSampleToSubmit,
                    sampleToSubmit: sampleToSubmit,
                    setSampleToDelete: setSampleToDelete,
                    sampleToDelete: sampleToDelete,
                    setTypeToDelete: setTypeToDelete,
                    typeToDelete: typeToDelete,
                    setSampleToReload: setSampleToReload,
                    sampleToReload: sampleToReload,
                    setArchivedVerbiage: setArchivedVerbiage,
                    setCallBackToBeMade: setCallBackToBeMade,
                    callBackToBeMade: callBackToBeMade,
                    sample_status: status,
                    setSampleClicked: setSampleClicked,
                    sampleClicked: sampleClicked,
                    addSampleCalled: addSampleCalled,
                    headerCalled: headerCalled,
                    setHeaderCalled: setHeaderCalled,
                    siteInfo: siteMetaData,
                    sampleRecentlyAdded: sampleRecentlyAdded,
                    setSampleRecentlyAdded: setSampleRecentlyAdded
                  }
                  return (<SampleHeaderRow key={`Header-${row.fuel_type}-${row.sub_category}-${row.method}-${row.category}`} allParams={createValues} />)
                }
                ))
                : (
                  <></>
                )}

            </TableBody>
                  )
                }
          </Table>
          {(!headers || (headers && headers.length < 1))
            && <NoSamplesOnSite onAddNewSampleClick={onAddNewSampleClick} site={siteMetaData} />
          }
        </TableContainer>
    </div>
  );
};